module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('h2', {
    staticClass: "h2p",
    attrs: {
      "id": "part1"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "26",
      "epub:type": "pagebreak",
      "id": "page_26",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "grayp"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "bigp"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2p1"
  }, [_vm._v("THE FIVE DISCIPLINES"), _c('span', {
    attrs: {
      "aria-label": "27",
      "epub:type": "pagebreak",
      "id": "page_27",
      "role": "doc-pagebreak"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("If traits are the soul of inclusive leaders, the five")]), _vm._v(" disciplines—those key competency composites—are the inclusive leaders in action. The five disciplines are what inclusive leaders achieve through skill, persistence, and practice. As the leaders master the inclusion competencies, they go through the same process as when they learn any other set of skills. There are things to learn and apply. There is trial and error. There is feedback and coaching. There is role modeling. There is learning from others. There are risk assessment, trade-off decisions, and bold actions. And these efforts are mobilized at the interpersonal, team, and organizational levels.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("The great news is that leaders seeking to be inclusive come to this work already possessing many strengths. They are accomplished in their fields, they are already leading others, and they have been recognized, promoted, and rewarded according to their leadership abilities. But as with mastering any other discipline, whether it be archery, cooking, playing the clarinet, gardening, home building, or you name it, there is always more to learn; there is more knowledge, more insights, and more experiences to be acquired on the road to a deep and nuanced understanding of what inclusive leadership entails and the ability to evaluate the capabilities of inclusive leaders.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("In "), _c('a', {
    attrs: {
      "href": "#/xhtml/part1#part1"
    }
  }, [_vm._v("part 1")]), _vm._v(", we plumb the meaning of each of the five disciplines and unpack each of the competencies within them. We bring the science behind the disciplines to life with the perspectives of inclusive leaders and informative sidebars highlighting others who exemplify the competencies."), _c('span', {
    attrs: {
      "aria-label": "28",
      "epub:type": "pagebreak",
      "id": "page_28",
      "role": "doc-pagebreak"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ab456b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 81
// module chunks = 0